// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"2643":"eb3fc579f2","5823":"a08c7895ec"}[chunkId] + ".chunk.css";
};